import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';

import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import blog1 from './../../Assets/blogs/blog1.jpg';
import blog4 from './../../Assets/blogs/blog4.jpg';
import blog5 from './../../Assets/blogs/blog5.jpg';
import blog8 from './../../Assets/blogs/blog8.jpg';
import CarouselBlog from './CarouselBlog';
import { blogsData } from './InterfacesBlogs';

function BlogsHome() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    usePersistedLanguage();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    return (
        <>
            <div
                className='App-intro'
            >
                <NavbarHome />
                {/*<div style={{display:'flex',flexDirection:'column',gap:'135px',alignItems:'center',}}>

                </div>*/}
                <div
                    className='frame72HomePage'
                >
                    <div className='frame75HomePage'>
                        <div
                            className='frame76HomePage'
                            style={{cursor:'pointer'}}
                            onClick={()=>{
                                navigate('/blog/1');
                            }}
                        >
                            <div className='frame77HomePage frame711227HomePage'>
                                <LazyLoadImage
                                    src={blog1}
                                    width={device=='desktop'?'600px':'100%'}
                                    height={'396px'}
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                            <div
                                className='frame78HomePage'

                            >
                                <div className='frame79HomePage'>
                                    <p className='frame80HomePage'>
                                        2024
                                    </p>
                                    <h4 className='titlesociete'>
                                        {i18n.t('Les Tendances de l\'IT qui Transforment notre Monde Numérique')}.
                                    </h4>
                                </div>
                                <p className='frame82HomePage'>
                                    {i18n.t('Par l\'équipe HTH')}
                                </p>
                            </div>
                        </div>
                        <div className='frame83HomePage'>
                            <div className='frame84HomePage'>
                                <h5 className='frame85HomePage'>
                                    {i18n.t('Articles en Vedette')}
                                </h5>
                            </div>

                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/blog/8');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog8}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2024
                                        </p>
                                        <div className='frame94HomePage'>
                                            <h6 className='blogTitles'>
                                                {i18n.t('Attirer les Meilleurs Talents Freelances en IT: Stratégies Éprouvées pour le Succès')}
                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/blog/5');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog5}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2024
                                        </p>
                                        <div className='frame94HomePage'>
                                            <h6 className='blogTitles'>
                                                {i18n.t('Comment Démarrer en Tant que Freelance en IT : Guide Complet pour Réussir votre Aventure Indépendante')}

                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/blog/4');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog4}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2024
                                        </p>
                                        <div
                                            className='frame94HomePage'

                                        >
                                            <h6 className='blogTitles'>
                                                {i18n.t('Quel Langage Choisir pour Développer sa Plateforme : Guide Pratique')}
                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <CarouselBlog
                    blogsData={blogsData}
                    pageType={'sourcing'}
                />
                <Footer/>
            </div>

        </>

    );

}
export default BlogsHome;